import { HStack, Skeleton, StackProps, VStack } from "@chakra-ui/react";

interface Props extends StackProps {
  row: number;
  column?: number;
  height?: number;
}

export const CardSkeleton = ({
  row,
  column = 1,
  height = 25,
  ...rest
}: Props) => {
  const value = "x";
  const rowLength = row;
  const columnLength = column;
  const rowArr = Array(rowLength).fill(value);
  const columnArr = Array(columnLength).fill(value);

  return (
    <VStack w={"100%"} {...rest}>
      {columnArr.map((item, indexColumn) => (
        <HStack
          key={indexColumn}
          w={"100%"}
          h={`${height}px`}
          borderRadius={"md"}
        >
          {rowArr.map((item, indexRow) => (
            <Skeleton
              key={indexRow}
              w={"100%"}
              h={`${height}px`}
              borderRadius={"md"}
            />
          ))}
        </HStack>
      ))}
    </VStack>
  );
};
